import { Component, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { QuickViewComponent } from '../../modal/quick-view/quick-view.component';
import { CartModalComponent } from '../../modal/cart-modal/cart-modal.component';
import { PRODUCT_IMAGE_PLACEHOLDER } from '../../../../core/constants/product-image.constants';
import {
  productDetailQueryParams,
  productDetailRouterLink
} from '../../../../core/utils/product-detail-route.util';
import { Params } from '@angular/router';
import { Product } from '../../../classes/product';
import { ProductService } from '../../../services/product.service';
import { BanksParticipantsModalService } from '../../../../core/services/banks-participants-modal.service';

@Component({
  selector: 'app-product-box-two',
  templateUrl: './product-box-two.component.html',
  styleUrls: ['./product-box-two.component.scss']
})
export class ProductBoxTwoComponent implements OnInit {

  @Input() product: Product;
  @Input() currency: any = this.productService.Currency;
  @Input() cartModal = false;
  /** Tarjeta catálogo TecBazar (/shop/collection) con mensualidades, contado, pill envío */
  @Input() catalogCard = false;
  /** Muestra el SKU debajo del título (home / watch). */
  @Input() showSku = false;
  /** Tarjeta home (DiezMasVendidos, LoMasNuevo, Promociones): pill Envío Gratis sobre el precio. */
  @Input() homeCard = false;

  @HostBinding('class.catalog-card')
  get catalogCardHost(): boolean {
    return !!this.catalogCard;
  }

  @HostBinding('class.home-card')
  get homeCardHost(): boolean {
    return !!this.homeCard;
  }

  @ViewChild('quickView') QuickView: QuickViewComponent;
  @ViewChild('cartModal') CartModal: CartModalComponent;

  public ImageSrc: string;

  constructor(
    private productService: ProductService,
    private readonly banksParticipantsModal: BanksParticipantsModalService
  ) { }

  ngOnInit(): void { }

  productDetailLink(): string[] {
    return productDetailRouterLink(this.product);
  }

  productDetailQueryParams(): Params {
    return productDetailQueryParams(this.product);
  }

  productSku(): string {
    const sku = this.product?.sku?.trim();
    if (sku) {
      return sku;
    }
    const fromTags = this.product?.tags?.[0];
    return fromTags != null && `${fromTags}`.trim() ? `${fromTags}`.trim() : '';
  }

  heroImage(product: Product): string {
    if (this.ImageSrc) {
      return this.ImageSrc;
    }
    return product?.images?.[0]?.src || PRODUCT_IMAGE_PLACEHOLDER;
  }

  /** Precio efectivo en moneda (con % descuento si aplica). */
  effectivePrice(product: Product): number {
    const p = Number(product?.price ?? 0) * Number(this.currency?.price ?? 1);
    const d = Number(product?.discount ?? 0);
    if (d > 0) {
      return p - (p * d / 100);
    }
    return p;
  }

  monthlyTwelve(product: Product): number {
    return this.effectivePrice(product) / 12;
  }

  showEnvioGratis(product: Product): boolean {
    if (product?.freeShipping) {
      return true;
    }
    const tags = product?.tags ?? [];
    return tags.some((t: string | undefined) =>
      String(t ?? '').toLowerCase().includes('envío') ||
      String(t ?? '').toLowerCase().includes('envio')
    );
  }

  Color(variants: Product['variants']): string[] {
    const uniqColor: string[] = [];
    if (!variants || !Array.isArray(variants)) {
      return uniqColor;
    }
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      if (v?.color && uniqColor.indexOf(v.color) === -1) {
        uniqColor.push(v.color);
      }
    }
    return uniqColor;
  }

  ChangeVariants(color: string, product: Product): void {
    if (!product?.variants || !Array.isArray(product.variants) || !product.images) {
      return;
    }
    product.variants.forEach((item) => {
      if (item.color === color) {
        product.images!.forEach((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src;
          }
        });
      }
    });
  }

  ChangeVariantsImage(src: string): void {
    this.ImageSrc = src;
  }

  addToCart(product: unknown): void {
    this.productService.addToCart(product);
  }

  addToCompare(product: unknown): void {
    this.productService.addToCompare(product);
  }

  openBanksConditionsClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.banksParticipantsModal.open();
  }

}
